import { Chain, ICToken, OdinToken, PlugToken } from '../interfaces/common'

export const asICToken = (token: PlugToken): ICToken => {
  if (token.chain === Chain.ICP && token.address) {
    return token as ICToken
  } else {
    throw 'Provided token is not compatible with ICToken type'
  }
}

export const asOdinToken = (token: PlugToken): OdinToken => {
  if (token.chain === Chain.ODIN) {
    return token as OdinToken
  } else {
    throw 'Provided token is not compatible with OdinToken type'
  }
}
